import {Injectable} from '@angular/core';
import localForage from 'localforage';
import {HttpClient} from "@angular/common/http";
import {firstValueFrom} from "rxjs";
import {EventsService} from "./events.service";

@Injectable({
  providedIn: 'root'
})
export class SettingsService {

  constructor(private http: HttpClient, private events: EventsService) {
    // this.init().then();
  }

  get(key: string): Promise<any> {
    return localForage.getItem(key);
  }

  set(key: string, value: any): Promise<any> {
    return localForage.setItem(key, value);
  }

  async delete(key: string) {
    return localForage.removeItem(key);
  }

  async init() {
    console.log('*** Synchronize settings ***');
    // const firstRunDone = await this.get('first-run-done');
    // console.log('first time running app:', firstRunDone);
    // if (!firstRunDone) {
    const defaults = await firstValueFrom(this.http.get('assets/json/defaults.json')) as {key: string, value: any}[];
    for (const entry of defaults) {
      await this.set(entry.key, entry.value);
    }
    await this.events.publish('settings-changed:upload');
      // console.log('saved initial settings in local storage.');
      // await this.set('first-run-done', true);
    // }
  }

}
